import { toast } from 'sonner';
import { useSoftphoneOptional } from '@/components/softphone/SoftphoneProvider';
import { formatPhoneForCall } from '@/utils/phone';

/**
 * Hook único de discagem — SEMPRE pelo softphone da Prime.
 *
 * ⛔ NÃO reintroduzir o fallback `window.open('tel:')`. Douglas 06/08: "eu quero
 * o uso manual exclusivo do nosso softphone, não quero deixar externo". O
 * fallback antigo abria o discador do computador sem avisar, e a ligação saía
 * sem gravação e sem registro no CRM.
 */
export function useLigar() {
  const softphone = useSoftphoneOptional();
  return (telefone: string | null | undefined, nome?: string) => {
    const num = formatPhoneForCall(telefone || '');
    if (!num) return;
    if (!softphone) {
      toast.error('A ligação NÃO foi feita — softphone indisponível nesta tela', {
        description: 'Recarregue a página (Ctrl+Shift+R). Ligar por fora do CRM não fica gravado.',
        duration: 9000,
      });
      return;
    }
    softphone.call(num, nome);
  };
}
